import React from 'react';
import { Lock, Edit2, Trash2 } from 'lucide-react';

const RoleGrid = ({ roles, canManageRoles, onEdit, onDelete, t }) => {
    const sortedRoles = [...roles].sort((a, b) => {
        const hierarchy = ['Kurucu', 'Ortak', 'Müdür', 'Kasiyer', 'Garson', 'Mutfak'];
        const indexA = hierarchy.indexOf(a.name);
        const indexB = hierarchy.indexOf(b.name);
        
        if (indexA !== -1 && indexB !== -1) return indexA - indexB;
        if (indexA !== -1) return -1;
        if (indexB !== -1) return 1;
        return a.name.localeCompare(b.name);
    });

    return (
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(min(300px, 100%), 1fr))', gap: '1.5rem' }}>
            <div className="card glass" style={{ border: '1px solid var(--border)', opacity: 0.8 }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '1rem' }}>
                    <div style={{ fontWeight: 700 }}>{t('roles.ownerTitle')}</div>
                    <Lock size={20} color="var(--primary)" />
                </div>
                <p style={{ fontSize: '0.875rem', color: 'var(--text-muted)' }}>{t('roles.ownerDesc')}</p>
            </div>

            {sortedRoles.map(r => (
            <div key={r.id} className="card" style={{ border: '1px solid var(--border)' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '1rem' }}>
                    <div style={{ fontWeight: 700 }}>{r.name}</div>
                    <div style={{ display: 'flex', gap: '8px' }}>
                        {canManageRoles && (
                            <>
                                <button onClick={() => onEdit(r)} style={{ background: 'transparent', color: 'var(--primary)' }}><Edit2 size={18} /></button>
                                <button onClick={() => onDelete(r)} style={{ background: 'transparent', color: '#ef4444' }}><Trash2 size={18} /></button>
                            </>
                        )}
                    </div>
                </div>
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: '4px' }}>
                    {Object.entries(r.permissions).map(([mod, perms]) => {
                        const count = Object.values(perms).filter(Boolean).length;
                        return count > 0 ? <span key={mod} style={{ fontSize: '0.7rem', background: 'var(--bg-main)', padding: '2px 8px', borderRadius: '4px' }}>{mod}: {count}</span> : null;
                    })}
                </div>
            </div>
        ))}
    </div>
    );
};

export default RoleGrid;
